import { render, staticRenderFns } from "./BasicInfo.template.vue?vue&type=template&id=06a1a501&scoped=true&"
var script = {}
import style0 from "./BasicInfo.template.vue?vue&type=style&index=0&id=06a1a501&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a1a501",
  null
  
)

export default component.exports